/* global $ */

import 'slick-carousel';

let $sliders = $('.js-slider');

function getIcon(name: string) {
  return `<svg class="icon icon-${name}"><use xlink:href="#icon-${name}"></use></svg>`;
}

function getButton(text: string, className: string, icon: string): string {
  return `
    <button type="button" class="${className}">
      <span class="sr-only">${text}</span>
      ${getIcon(icon)}
    </button>
  `;
}

const generalSlider = {
  initialize() {
    $sliders = $('.js-slider')

    if ($sliders.length) {
      this.create();
    }
  },

  create() {
    $sliders.each((i: number, slider: HTMLElement) => {
      const $slider: any = $(slider);

      if ($slider.hasClass('slick-initialized')) {
        return;
      }

      const options = $slider.data();

      const config: any = {
        prevArrow: getButton('Vorige', 'slider__arrow slick-prev', 'arrow-left'),
        nextArrow: getButton('Volgende', 'slider__arrow slick-next', 'arrow-right'),
      };

      if (typeof options !== 'undefined') {
        const optionKeys = Object.keys(options);

        optionKeys.forEach((option: string) => {
          const regex = new RegExp('^slider', 'g');

          if (regex.test(option)) {
            let transformedOption = option.replace('slider', '');
            transformedOption = transformedOption[0].toLowerCase() + transformedOption.slice(1);

            config[transformedOption] = options[option];
          }
        });
      }

      $slider.slick(config);
    });
  },
};

export default generalSlider;
